import { useTranslation } from 'react-i18next'

import ClearOutStockCartModal from '@features/cart/ui/clear-cart/out-stock-modal'
import styles from '@features/cart/ui/modal/styles.module.scss'
import { useModalStore } from '@features/modal'




export default function useClearOutStockCart () {
  const { openModal, closeModal } = useModalStore()
  const { t: tc } = useTranslation('cart')

  return {
    openClearOutStockModal: () =>
      openModal('clearOutStockProduct', <ClearOutStockCartModal />, {
        classes: {
          content: styles['modal-content'],
        },
        title: tc('clearOutStock.title'),
        description: tc('clearOutStock.desc'),
      }),
    closeClearOutStockModal: () => closeModal('clearOutStockProduct'),
  }
}
